const _validImageExtensions = ["jpg", "jpeg", "bmp", "gif", "png", "svg"];    

export const ValidateImageUpload = (inputFile, maxSize) => {
    return ValidateFileSize(inputFile, maxSize) && ValidateFileExtension(inputFile, _validImageExtensions)
}

export const ValidateFileSize = (inputFile, maxSize) => {
    let fileType = inputFile.type.split("/")[0]

    if (fileType === "image") {
        if(inputFile.size > maxSize) {
            return false
        }
    } else {
        return false
    }
    return true
}

export const ValidateFileExtension = (inputFile, _validFileExtensions) => {
    let fileType = inputFile.type.split("/")[0]
    let fileExtension = inputFile.type.split("/")[1]

    if (fileType === "image") {
        var isValid = _validFileExtensions.includes(fileExtension);
   
        if (!isValid) {
            return false;
        }
    } else {
        return false
    }

    return true;
}